var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _a;
import { ValidationCollector } from "@common/types/validationCollector";
import { isNullOrUndefined } from "@common/utils/functions";
import MachineRegistrationCreationService from "../services/machineRegistrationCreationService";
import { Registration } from "../types/internal/registration";
import { ACTION_TYPE } from "./types/actionType";
import { COMMIT_TYPE } from "./types/commitType";
export var actions = (_a = {},
    _a[ACTION_TYPE.Initialize] = function (_a, initializationData) {
        var commit = _a.commit, dispatch = _a.dispatch;
        return __awaiter(this, void 0, void 0, function () {
            var registration;
            return __generator(this, function (_b) {
                registration = new Registration();
                registration.machineRegistrationData.serialNumber = initializationData.serialNumber;
                registration.nonce = initializationData.nonce;
                registration.machineRegistrationData.nonce = registration.nonce;
                commit(COMMIT_TYPE.Initializing, true);
                commit(COMMIT_TYPE.Registration, registration);
                commit(COMMIT_TYPE.InitializationData, initializationData);
                commit(COMMIT_TYPE.Initializing, false);
                dispatch(ACTION_TYPE.LoadMachineInformation);
                return [2 /*return*/];
            });
        });
    },
    _a[ACTION_TYPE.LoadMachineInformation] = function (_a) {
        var commit = _a.commit, state = _a.state;
        var _b;
        return __awaiter(this, void 0, void 0, function () {
            var serialNumber, result;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        serialNumber = (_b = state.registration) === null || _b === void 0 ? void 0 : _b.machineRegistrationData.serialNumber;
                        if (isNullOrUndefined(serialNumber))
                            return [2 /*return*/];
                        if (state.isLoadingMachineInformation)
                            return [2 /*return*/];
                        commit(COMMIT_TYPE.IsLoadingMachineInformation, true);
                        return [4 /*yield*/, MachineRegistrationCreationService.getMachineInformation(serialNumber)];
                    case 1:
                        result = _c.sent();
                        commit(COMMIT_TYPE.IsLoadingMachineInformation, false);
                        if (!result.isSuccess) {
                            commit(COMMIT_TYPE.ValidationCollector, new ValidationCollector(result.errorModel));
                            return [2 /*return*/];
                        }
                        commit(COMMIT_TYPE.MachineInformation, result.result);
                        return [2 /*return*/];
                }
            });
        });
    },
    _a[ACTION_TYPE.CreateMachineRegistration] = function (_a) {
        var state = _a.state, commit = _a.commit, dispatch = _a.dispatch;
        return __awaiter(this, void 0, void 0, function () {
            var model, result;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (state.errors != null && state.errors.length > 0)
                            return [2 /*return*/];
                        model = state.registration;
                        if (model.machineRegistrations.some(function (x) { return x.serialNumber == model.machineRegistrationData.serialNumber; })) {
                            commit(COMMIT_TYPE.ValidationCollector, new ValidationCollector({ errors: ["Serial number already used in this batch"] }));
                            return [2 /*return*/];
                        }
                        commit(COMMIT_TYPE.ValidationCollector, new ValidationCollector(null));
                        commit(COMMIT_TYPE.IsCreating, true);
                        return [4 /*yield*/, MachineRegistrationCreationService.createRegistration(model)];
                    case 1:
                        result = _b.sent();
                        commit(COMMIT_TYPE.IsCreating, false);
                        if (result.isSuccess) {
                            dispatch(ACTION_TYPE.Reset);
                            return [2 /*return*/];
                        }
                        commit(COMMIT_TYPE.ValidationCollector, new ValidationCollector(result === null || result === void 0 ? void 0 : result.errorModel));
                        return [2 /*return*/];
                }
            });
        });
    },
    _a[ACTION_TYPE.ValidateAndAddAttachment] = function (_a) {
        var state = _a.state, commit = _a.commit, dispatch = _a.dispatch;
        var _b;
        return __awaiter(this, void 0, void 0, function () {
            var model, sn, validationResult, result;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (state.errors != null && state.errors.length > 0)
                            return [2 /*return*/];
                        model = state.registration;
                        commit(COMMIT_TYPE.IsAdding, true);
                        sn = (_b = model.machineRegistrationData.serialNumber) === null || _b === void 0 ? void 0 : _b.toLowerCase();
                        if (model.machineRegistrations.some(function (x) { var _a; return ((_a = x.serialNumber) === null || _a === void 0 ? void 0 : _a.toLowerCase()) == sn; })) {
                            commit(COMMIT_TYPE.ValidationCollector, new ValidationCollector({ errors: ["Serial number already used in this batch"] }));
                            commit(COMMIT_TYPE.IsAdding, false);
                            return [2 /*return*/];
                        }
                        commit(COMMIT_TYPE.ValidationCollector, new ValidationCollector(null));
                        return [4 /*yield*/, MachineRegistrationCreationService.validateMachineRegistartion(model)];
                    case 1:
                        validationResult = _c.sent();
                        if (!validationResult.isSuccess) return [3 /*break*/, 3];
                        return [4 /*yield*/, MachineRegistrationCreationService.AddAttachment(model)];
                    case 2:
                        result = _c.sent();
                        if (result.isSuccess) {
                            commit(COMMIT_TYPE.PartialSubmit, result.result);
                            dispatch(ACTION_TYPE.ResetMachine, result.result);
                            commit(COMMIT_TYPE.IsAdding, false);
                            return [2 /*return*/];
                        }
                        else {
                            commit(COMMIT_TYPE.ValidationCollector, new ValidationCollector(result === null || result === void 0 ? void 0 : result.errorModel));
                            commit(COMMIT_TYPE.IsAdding, false);
                            return [2 /*return*/];
                        }
                        _c.label = 3;
                    case 3:
                        commit(COMMIT_TYPE.ValidationCollector, new ValidationCollector(validationResult === null || validationResult === void 0 ? void 0 : validationResult.errorModel));
                        commit(COMMIT_TYPE.IsAdding, false);
                        return [2 /*return*/];
                }
            });
        });
    },
    _a[ACTION_TYPE.Reset] = function (_a) {
        var commit = _a.commit, state = _a.state;
        var machineRegistration = new Registration();
        machineRegistration.nonce = state.initializationData.nonce;
        machineRegistration.machineRegistrationData.nonce = state.initializationData.nonce;
        //Stay on the page. This page is used by external customers + clear previous entries
        commit(COMMIT_TYPE.Registration, machineRegistration);
        commit(COMMIT_TYPE.PartialSubmit, null);
    },
    _a[ACTION_TYPE.ResetMachine] = function (_a, value) {
        var commit = _a.commit, state = _a.state;
        var _b;
        var registrationData = (_b = state.registration) === null || _b === void 0 ? void 0 : _b.machineRegistrationData;
        if (isNullOrUndefined(registrationData))
            return;
        commit(COMMIT_TYPE.MachineRegistrationData, registrationData);
    },
    _a);
